module.exports = __webpack_public_path__ + "static/media/动物片假名之歌.6bc6ef92.flv";